export function HeroDescription({ description }) {
	return (
		<p className="mt-6 text-lg leading-8 text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
			{description}
		</p>
	)
}